"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

(0, _jquery2.default)(window).on("load", function () {
  var _this = this;

  if ((0, _jquery2.default)("body").attr("id") === "virtual-try-on") {
    // set variables
    var dittoPopup = (0, _jquery2.default)(".js-ditto-popup");
    var dittoWrapper = (0, _jquery2.default)("#dittoWrapper");

    // move frames to bottom on mobile
    if ((0, _jquery2.default)(this).width() < 1024) {
      (0, _jquery2.default)(".ditto-grid__item .item-frames").appendTo("#dittoWrapper").css("display", "flex");
    }

    // save data to cookie
    var saveDittoId = function saveDittoId(scanId) {
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      var expires = date.toUTCString();
      _this.scanId = scanId;
      document.cookie = "ditto_id=" + scanId + "; expires=" + expires + "; SameSite=Strict; path=/";
    };

    // grab data from cookie
    var getDittoId = function getDittoId() {
      var value = document.cookie.split(";").filter(function (cookie) {
        var key = cookie.split("=")[0].trim();
        var pair = cookie.split("=")[1].trim();

        return key === "ditto_id" ? pair : false;
      });

      if (value.length > 0) {
        return value[0].split("=")[1].trim();
      } else {
        return "";
      }
    };

    // scan face
    var addOverlay = function addOverlay(domSelector, glassesId) {
      // Check compatibility flow
      var dittoFlowTypeTest = Ditto.flowType;

      // initiate ditto
      _jquery2.default.get("/tools/auth_key/ditto-auth-credentials/", function (response) {
        var dittoCreation = new Ditto.Scan({
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          domSelector: domSelector,
          accessKey: response["X-Ditto-Access-Key-Id"],
          partnerId: "sunniesstudios",
          font: "montserrat",
          partnerSignature: response["X-Ditto-Signature"],
          enableFaceInsights: true
        }, {
          success: function success(callbackObject) {
            console.log("success", callbackObject);
            dittoPopup.removeClass("active");
            if (dittoFlowTypeTest == "COMPATIBILITY") {
              alert("SUCCESS");
              dittoPopup.css("display", "block");
              (0, _jquery2.default)("#scan-iframe").css("index", "2");
            }
            displayTryOn("#dittoDisplay", glassesId, callbackObject.scanId);
            dittoWrapper.addClass("ditto-overlay-active");
            dittoCreation.destroy();
            saveDittoId(callbackObject.scanId);
            document.querySelector("html").classList.remove("no-scroll");
          },
          failure: function failure(callbackObject) {
            console.log("failure", callbackObject);
          },
          progress: function progress(callbackObject) {
            console.log("progress", callbackObject);
            document.querySelector("html").classList.add("no-scroll");

            if (dittoFlowTypeTest == "COMPATIBILITY") {
              document.querySelector("#scan-iframe").style.zIndex = "10";
            }
          },
          close: function close(callbackObject) {
            console.log("close", callbackObject);
            (0, _jquery2.default)("#DittoPopup").css("display", "initial");
            dittoPopup.removeClass("active");
            document.querySelector("html").classList.remove("no-scroll");
          }
        });
      });
    };

    // display scanned face
    var displayTryOn = function displayTryOn(domSelector, glassesId, scanId) {
      _jquery2.default.get("/tools/auth_key/ditto-auth-credentials/?message=" + scanId, function (response) {
        var dittoTryOn = new Ditto.Overlay({
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          partnerId: "sunniesstudios",
          domSelector: domSelector,
          scanId: scanId,
          glassesId: glassesId,
          accessKey: response["X-Ditto-Access-Key-Id"],
          partnerSignature: response["X-Ditto-Signature"],
          overlaySignature: response["X-Ditto-Signature"]
        }, {
          success: function success(data) {
            var wrapper = document.getElementById("dittoDisplay");
            var removeRetakeButton = document.querySelector(".js-retake-ditto");

            if (removeRetakeButton) {
              wrapper.removeChild(removeRetakeButton);
            }

            var button = document.createElement("button");
            button.type = "button";
            button.classList.add("Product__details-lifestyle__ditto", "btn", "js-retake-ditto", "btn--black");
            button.innerText = "Retake";
            document.getElementById("dittoDisplay").appendChild(button);

            var buttonHint = document.getElementById("dittoHint");
            if (buttonHint) {
              document.getElementById("dittoDisplay").appendChild(buttonHint);
              buttonHint.classList.add("show-hint");
            }

            var retakeButtonElement = document.querySelector(".js-retake-ditto");
            retakeButtonElement.addEventListener("click", function () {
              triggerRetake(glassesId);
            });
            retakeButtonElement.addEventListener("keydown", function (event) {
              return event.keyCode === 13 ? triggerRetake(glassesId) : false;
            });
          },
          failure: function failure() {
            console.log("failure");
          }
        });
      });
    };

    var triggerRetake = function triggerRetake(sku) {
      dittoPopup.addClass("active");
      addOverlay("#DittoPopup", sku);
    };

    // initiate default model & frame
    // displayOverlay(
    //   "#dittoDisplay",
    //   $("#dittoFrame1").data("variant-sku"),
    //   "ditto_model_female_01"
    // );

    // // change product data on change of frame
    (0, _jquery2.default)('[name="ditto_frame"]').on("change", function () {
      if (dittoWrapper.hasClass("ditto-overlay-active")) {
        var sku = (0, _jquery2.default)(this).data("variant-sku");
        var scanId = getDittoId();

        displayTryOn("#dittoDisplay", sku, scanId);
      }
    });

    // get started
    (0, _jquery2.default)("#startDitto").on("click", function () {
      // set variables
      var sku = void 0;
      var scanId = getDittoId();

      // check which frame frame to use
      (0, _jquery2.default)('[name="ditto_frame"]').each(function () {
        if ((0, _jquery2.default)(this).prop("checked")) {
          sku = (0, _jquery2.default)(this).data("variant-sku");
        }
      });

      // check if you have id
      if (scanId === "") {
        // initiate ditto
        dittoPopup.addClass("active");
        addOverlay("#DittoPopup", sku);
      } else {
        // load your previous scanned face
        dittoWrapper.addClass("ditto-overlay-active");
        displayTryOn("#dittoDisplay", sku, scanId);
      }
    });
  }
});